import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Icon,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ModalOffert from "./ModalOffert";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

const CardOffert = ({ offert }) => {
  const { membershipStatus } = useSelector((state) => state.userReducer);
  const { status } = useSelector((state) => state.userReducer);
  const [open, setOpen] = useState(false);
  return (
    <Card
      sx={{
        display: "flex",
        // maxWidth: 450,
        width: { xs: 250, sm: 320 },
      }}
    >
      <ModalOffert offert={offert} open={open} setOpen={setOpen} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardContent sx={{ flex: "1 0 auto" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <Typography component="div" variant="h6">
                {offert?.nameEstablishment ?? "Nombre del establecimiento."}
              </Typography>
              <Typography variant="h5" component="div" color="#e7ef7d">
                {offert?.discount ?? "Descuento."}
              </Typography>
            </Box>
            <Box sx={{ padding: 2 }}>
              <LocalOfferIcon sx={{ color: "#e7ef7d", fontSize: 50 }} />
            </Box>
          </Box>
          <Typography
            variant="subtitle1"
            component="div"
            sx={{ color: "text.secondary" }}
          >
            {offert?.description ?? "Descripción de la oferta."}
          </Typography>
        </CardContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3, padding: 2 }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#e7ef7d" }}
            onClick={() => {
              if (status !== "active" || membershipStatus !== "active") {
                toast.error(
                  `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
                );
                return;
              }
              setOpen(true);
            }}
          >
            Ver
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default CardOffert;
